.title {
  display: flex;
  align-items: center;
  margin-bottom: 1.2rem;
  color: var(--color-semantic-text-neutral30);
  font-weight: bold;
  font-size: 1.4rem;
}

.title::after {
  flex: 1;
  height: 0.1rem;
  margin-left: 0.8rem;
  background-color: var(--color-semantic-surface-neutral30);
  content: '';
}

.item {
  display: flex;
  justify-content: space-between;
  margin-top: 1.2rem;
}

.value {
  margin-left: 1.2rem;
}

.lineThrough {
  font-weight: normal;
  text-decoration: line-through;
}
